import React, { Component } from "react";
import { connect } from "react-redux";
import _get from "lodash/get";
import Head from "next/head";
import getConfig from "next/config";
const {
  publicRuntimeConfig: {
    settings: { websiteStatics, baseUrl, websiteName, localSeller },
    content,
  },
} = getConfig();

import Router from "next/router";

import { addToCartApi, getDonationReportApi } from "@lib/api/index";
import { formatPrice } from "@lib/helpers";

import {
  apiCall,
  getCmsBlocks,
  removeSpinner,
  addSpinner,
} from "@store/app/actions";

import { initCartToken, getCart, getDummyCart } from "@store/cart/actions";

import ErrorPage from "@containers/ErrorPage";
import Loading from "@components/Loading";
import ContentEditorView from "@components/ContentEditorView/index";
import Button from "@components/Button";

import DonationForm from "@containers/DonationForm";
import AmountFlipCounter from "@components/AmountFlipCounter";

class DonatieCovid19 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      initialValues: {
        customer_type: 1,
        address_type: 1,
      },
      initialAddress: false,
      ready: false,
      fetching: false,
      donation: "",
      altaSuma: false,
      altaSumaValidation: false,
      showAdd: false,
      showNews: false,
    };

    this.partnersDonations = [
      {
        name: "UniCredit Bank",
        amount: 631192,
      },
      {
        name: "Whirlpool",
        amount: 146252,
      },
      {
        name: "De'Longhi",
        amount: 100000,
      },
      {
        name: "Hama",
        amount: 48400,
      },
      {
        name: "Media Invest",
        amount: 48400,
      },
      {
        name: "PC-coolers",
        amount: 35000,
      },
    ];

    this.partnersDonationsAmount = this.partnersDonations.reduce(
      (totalAmount, donation) => totalAmount + donation.amount,
      0
    );

    this.otherDonationsAmount = 508200;
  }

  static async getInitialProps(ctx) {
    const { reduxStore } = ctx;

    if (websiteName !== "altex") {
      if (ctx.res) {
        ctx.res.statusCode = 404;
      }
    }

    await reduxStore.dispatch(
      getCmsBlocks([
        "donatie_covid",
        "donatie_covid_jos",
        "donatie_covid_total",
        "donatie_covid_stiri",
      ])
    );

    const donationReportReq = await reduxStore.dispatch(
      apiCall({
        spinner: false,
        apiCall: getDonationReportApi,
        returnResponse: true,
      })
    );

    return {
      donationReport:
        donationReportReq &&
        donationReportReq.data &&
        donationReportReq.data.data
          ? donationReportReq.data.data
          : null,
    };
  }

  sessionData = async () => {
    if (!this.state.ready && !this.state.fetching) {
      this.setState(
        {
          fetching: true,
        },
        async () => {
          if (!this.props.cart.isInitial) {
            if (this.props.cart.token) {
              const cartReq = await this.props.getCart();

              if (cartReq) {
                this.setState({
                  cart: cartReq.cart,
                  ready: true,
                  fetching: false,
                });
              }
            } else {
              console.log("Getting dummy cart for donation options.");
              const dummyCartReq = await this.props.getDummyCart();

              if (dummyCartReq) {
                console.log("Got dummy cart donation options.");

                this.setState({
                  cart: dummyCartReq.cart,
                  ready: true,
                  fetching: false,
                });
              }
            }
          }
        }
      );
    }
  };

  async componentDidMount() {
    this.sessionData();
  }

  async componentDidUpdate() {
    this.sessionData();
  }

  addDonationToCart = async (sum) => {
    const donationSku =
      _get(this.state, "cart.donation_options.sku", null) ||
      _get(this.props, "cart.miniCart.donation_options.sku", null);

    if (!(donationSku && sum)) return null;

    const payload = {
      sku: donationSku,
      donation: sum,
      // sku: 'SMTMWC22RMA',
      quantity: 1,
      seller_id: localSeller,
    };

    this.props.addSpinner("placeDonation", `Trimitere donatie...`);

    const addResponse = await this.props.apiCall({
      spinner: false,
      alert: true,
      apiCall: addToCartApi,
      apiArgs: [payload],
      returnResponse: true,
    });

    this.props.removeSpinner("placeDonation");

    if (addResponse && addResponse.ok) {
      const cartToken = _get(addResponse, `data.cart.token`, false);

      if (cartToken) {
        await this.props.initCartToken(cartToken);
        Router.push(`/cos-cumparaturi/`);
      }
    }
  };

  render() {
    const { cmsObjBlocks, cart: storeCart, donationReport } = this.props;
    const { ready, showNews } = this.state;

    const cart = storeCart.miniCart ? storeCart.miniCart : this.state.cart;

    if (websiteName !== "altex") {
      return <ErrorPage layout="404" />;
    }

    const donationSums = _get(cart, "donation_options.sums", null);
    let donatedSum = null;
    if (cart && cart.donation) {
      const donationSku = Object.keys(cart.cart_items).find(
        (it) => it.indexOf("DONATIECOVID") > -1
      );
      donatedSum = cart.cart_items[donationSku].total;
    }

    return (
      <>
        <Head>
          <title>Donatie #impreuna</title>
          <meta
            name="description"
            content="Doneaza si tu alaturi de Altex pentru lupta impotriva COVID-19. #impreuna"
          />
        </Head>
        <div
        //className="relative"
        >
          <style jsx global>{`
            .cmsDonatie {
              margin-left: 10px;
              margin-right: 10px;
              font-size: 16px;
              font-weight: 100;
              line-height: 1.5;
            }
            .cmsDonatie p {
              font-size: 16px;
              font-weight: 100;
              line-height: 1.5;
            }

            .cmsDonatie p b {
              font-weight: bold;
            }

            .cmsDonatie ul {
              list-style-image: url("${websiteStatics}/images/donatii-covid-v2/altex-star-list.png");
            }

            .cmsDonatie li {
              font-size: 1rem;
              line-height: 1.5;
            }

            .cmsDonatie h2,
            .cmsDonatie h2 *,
            .cmsDonatie h3,
            .cmsDonatie h3 * {
              text-align: left;
              color: #d71440;
              font-size: 32px;
              font-family: Trebuchet MS, Helvetica Neue, Helvetica, Arial,
                sans-serif;
              text-transform: inherit;
              letter-spacing: normal;
              line-height: 1.2;
            }

            .cmsDonatie h2,
            .cmsDonatie h3 {
              margin-top: 0.75em;
            }

            .cmsDonatie h2:after,
            .cmsDonatie h3:after {
              content: "";
              display: block;
              width: 60px;
              height: 2px;
              background-color: #f5cb38;
              margin-top: 10px;
            }

            .DonatiePageForm {
              background: #e7991b
                url("${websiteStatics}/images/donatii-covid-v3/donation_bg.jpg")
                no-repeat center center;
              background-size: cover;
            }

            ._DonatieHeader {
              background-color: #fff;
              background-image: url("${websiteStatics}/images/donatii-covid-v2/oameni2.jpg");
              background-repeat: no-repeat;
              background-position: center top;
            }
            ._DonatieHeader::after {
              content: "";
              position: absolute;
              left: 0;
              right: 0;
              bottom: 0;
              height: 20px;

              background: rgb(255, 255, 255);
              background: linear-gradient(
                0deg,
                rgba(255, 255, 255, 1) 0%,
                rgba(255, 255, 255, 0) 100%
              );
            }
          `}</style>

          <div className="container">
            <div>
              <a href="#doneaza-si-tu">
                <img
                  src={`${websiteStatics}/images/donatii-covid-v3/top.jpg`}
                  alt={content.websiteTitle}
                  width="1000"
                  height="600"
                  className="block mx-auto"
                />
              </a>
            </div>
          </div>

          <div
            className="container mx-auto text-black"
            style={{ maxWidth: 740 }}
          >
            <img
              src={`${websiteStatics}/images/donatii-covid-v3/impreuna.jpg`}
              width="740"
              height="212"
              className="block mx-auto my-4"
            />
          </div>

          <div className="lg:flex items-center">
            <div className="lg:w-3/12"></div>
            <div
              className="container mx-auto text-black lg:w-6/12"
              style={{ maxWidth: 700 }}
            >
              <div
                className="text-center mb-6 mx-auto"
                style={{ maxWidth: 700 }}
              >
                <div className="cmsDonatie text-left">
                  {!!cmsObjBlocks.donatie_covid && (
                    <ContentEditorView content={cmsObjBlocks.donatie_covid} />
                  )}
                </div>
              </div>

              <div className="mt-4 mb-6 px-3 w-full block hidden sm:block">
                <img
                  src={`${websiteStatics}/images/donatii-covid-v3/sponsori.png`}
                  width="680"
                  height="240"
                  className="w-full"
                />
              </div>

              <div className="mt-4 mb-6 px-12 w-full block sm:hidden">
                <img
                  src={`${websiteStatics}/images/donatii-covid-v3/sponsori-mobile.png`}
                  width="360"
                  height="400"
                  className="w-full"
                />
              </div>
            </div>
            <div className="lg:w-3/12"></div>
          </div>

          <div className="lg:flex DonatiePageForm" id="doneaza-si-tu">
            <div className="lg:w-3/12"></div>
            <div className="container mx-auto text-black lg:w-6/12 py-16">
              {ready ? (
                <>
                  {cart && cart.donation ? (
                    <>
                      <div>
                        <img
                          src={`${websiteStatics}/images/donatii-covid-v2/success-icon.png`}
                          width="416"
                          height="245"
                          className="block mx-auto pr-8"
                        />
                      </div>
                      <div className="text-black text-center text-3xl leading-normal font-thin">
                        <p>
                          In acest moment ai in cos o donatie in valoare de{" "}
                          {donatedSum} lei
                        </p>
                      </div>

                      <div className="text-center">
                        <Button
                          title={`Vezi cosul tau`}
                          display="inline"
                          size="normal"
                          variant="primary"
                          href={`${baseUrl}/cos-cumparaturi/`}
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <DonationForm
                        donationSums={donationSums}
                        addDonationToCart={this.addDonationToCart}
                      />
                    </>
                  )}
                </>
              ) : (
                <Loading height={100} />
              )}
            </div>
            <div className="lg:w-3/12"></div>
          </div>

          <div className="lg:flex">
            <div className="lg:w-2/12"></div>
            <div
              className="container mx-auto text-black lg:w-8/12"
              style={{ maxWidth: 700 }}
            >
              {/* <div className="cmsDonatie text-left">
                {!!cmsObjBlocks.donatie_covid_total && (
                  <ContentEditorView content={cmsObjBlocks.donatie_covid_total} />
                )}
              </div> */}

              {!!(donationReport && donationReport.amount) && (
                <div className="py-4">
                  <h3 className="text-center text-4xl mb-4">
                    <div>Pana in acest moment s-au donat</div>
                    <div className="text-red-brand text-5xl sm:text-6xl mt-4 font-extrabold u-text-headings-font u-text-bold">
                      {`${formatPrice(
                        donationReport.amount +
                          this.partnersDonationsAmount +
                          this.otherDonationsAmount,
                        "int"
                      )}`}
                      <span className="text-5xl ml-1">LEI</span>
                    </div>
                  </h3>
                </div>
              )}

              {donationReport &&
                donationReport.last_orders &&
                donationReport.last_orders.length > 0 && (
                  <div className="cmsDonatie mb-16">
                    <h3 className="font-bold">Cele mai recente donatii</h3>
                    <ul className="mt-6 pl-0 text-xs">
                      {donationReport.last_orders.map((donationItem, i) => (
                        <li
                          key={`donation-item-${i}`}
                          className="mb-5"
                          style={{
                            listStyleImage: "none",
                          }}
                        >
                          <span className="bg-gray-lighter rounded-l px-5 py-2">
                            <strong className="font-bold">
                              {donationItem.customer_firstname},
                            </strong>
                            <span className="ml-1">{donationItem.region}</span>
                          </span>

                          <span
                            className="px-5 py-2 rounded-r"
                            style={{ backgroundColor: "#F6F5F5" }}
                          >
                            <strong className="font-bold">
                              {formatPrice(
                                Number(donationItem.row_total),
                                "int"
                              )}
                            </strong>{" "}
                            lei
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

              <div className="cmsDonatie mb-16">
                <h3 className="font-bold">Donatiile partenerilor nostri</h3>

                <div className="flex flex-col sm:flex-row flex-wrap">
                  {this.partnersDonations.map((donation, index) => (
                    <div key={index} className="mb-12 w-full sm:w-1/2 shrink-0">
                      <AmountFlipCounter amount={donation.amount} />

                      <div className="text-lg mt-2 font-bold">
                        {donation.name}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {!!cmsObjBlocks.donatie_covid_stiri && (
                <div className="pb-4">
                  <div className="cmsDonatie">
                    <h3 className="font-normal">
                      Afla cum salvam vieti impreuna
                    </h3>
                    {/*
                  {!showNews &&
                    <p>
                      Dotam sectiile de terapie intensiva cu aparatura de ultima generatie si salvam vietile noastre, ale parintilor nostri, ale prietenilor nostri…
                    </p>
                  }
                   */}

                    <div
                      className="mt-4 mb-4"
                      _style={{ marginLeft: 10, marginRight: 10 }}
                    >
                      <Button
                        title={
                          showNews ? "Mai putine detalii" : "Mai multe detalii"
                        }
                        display="inline"
                        size="small"
                        variant="primary"
                        onClick={() => this.setState({ showNews: !showNews })}
                      />
                    </div>
                  </div>

                  {showNews && (
                    <div className="cmsDonatie text-left">
                      {!!cmsObjBlocks.donatie_covid_stiri && (
                        <ContentEditorView
                          content={cmsObjBlocks.donatie_covid_stiri}
                        />
                      )}
                    </div>
                  )}
                </div>
              )}

              <div className="cmsDonatie text-left">
                {!!cmsObjBlocks.donatie_covid_jos && (
                  <ContentEditorView content={cmsObjBlocks.donatie_covid_jos} />
                )}
              </div>

              <div className="text-red-brand text-3xl text-center font-thin mt-8">
                <p>Fiecare donatie conteaza!</p>
                <p>Iti multumim pentru implicare!</p>
                <Button
                  title={`Doneaza si tu!`}
                  display="inline"
                  size="normal"
                  variant="primary"
                  href="#doneaza-si-tu"
                />
              </div>
            </div>
            <div className="lg:w-2/12"></div>
          </div>
        </div>

        {/* <div className="md:flex py-4 items-center">
          <div className="px-2 md:w-1/4">
            <Link href={baseUrl} passHref>
            <a>
            <img
              src={`${websiteStatics}/images/donatii-covid/logo/fundatia-altex.jpg`}
              alt={content.websiteTitle}
              width="255"
              height="40"
              className="block mx-auto"
            />
            </a>
            </Link>
          </div>
          <div className="px-2 md:w-1/4 mt-6 md:mt-0"></div>
          <div className="px-2 md:w-1/4 mt-6 md:mt-0"></div>
          <div className="px-2 md:w-1/4 mt-6 md:mt-0">
            <img
              src={`${websiteStatics}/images/donatii-covid/logo/san.jpg`}
              alt={content.websiteTitle}
              width="150"
              height="40"
              className="block mx-auto"
            />
          </div>
        </div> */}
      </>
    );
  }
}

DonatieCovid19.pageLayout = "default";
DonatieCovid19.layoutProps = {
  // hideHeader: true,
  // hideFooter: true,
  // hideTopBar: true,
  noContainer: true,
};

export default connect(
  (state) => ({
    cart: state.cart,
    user: state.user,
    cmsObjBlocks: state.app.cmsObjBlocks,
  }),
  {
    initCartToken,
    apiCall,
    removeSpinner,
    addSpinner,
    getCart,
    getDummyCart,
  }
)(DonatieCovid19);
